import React__default from 'react';
import { ScrollIntoView } from '@grandvisionhq/common';
import { Heading, Text } from '@grandvisionhq/elements';

const SuccessMessage = ({ labels  })=>/*#__PURE__*/ React__default.createElement("section", {
        className: "customer-support__success",
        "data-t": "customer-support-success"
    }, /*#__PURE__*/ React__default.createElement(ScrollIntoView, null, /*#__PURE__*/ React__default.createElement(Heading, {
        component: "h2",
        variant: 'medium',
        align: 'center'
    }, labels.title), /*#__PURE__*/ React__default.createElement(Text, {
        variant: "body",
        align: "center"
    }, labels.content)))
;
var SuccessMessage$1 = SuccessMessage;

export { SuccessMessage$1 as default };
//# sourceMappingURL=SuccessMessage.js.map
